import {
  AppShell,
  Burger,
  Group,
  Header,
  MediaQuery,
  Navbar,
  useMantineTheme,
} from "@mantine/core";
import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { allowUserLogin } from "../../Helpers";
import JobSeekerSideBar from "../../jobseekerComponents/jobseekerSidebar";
import routeNames from "../../routes/routeNames";

const JobseekerHome = () => {
  const theme = useMantineTheme();
  const [opened, setOpened] = useState(false);
  const [loadComponent, setLoadComponent] = useState(false);
  const location = useLocation();
  useEffect(() => {
    allowUserLogin("JobSeeker")?.then(setLoadComponent);
  }, []);
  return (
    loadComponent &&
    (location.pathname === routeNames.jobSeeker.dashboard ||
    location.pathname === routeNames.jobSeeker.jobapplications ||
    location.pathname === routeNames.jobSeeker.messages ||
    location.pathname === routeNames.jobSeeker.connections ||
    location.pathname === routeNames.jobSeeker.homeFeed ||
    location.pathname === routeNames.jobSeeker.myposts ||
    location.pathname.includes("/jobSeeker/companyPosts/") ||
    location.pathname === "/jobSeeker/settings" ||
    location.pathname === "/jobSeeker/connections/companies" ||
    location.pathname === "/jobSeeker/connections/jobseekers" ||
    location.pathname === "/jobSeeker/myprofile" ? (
      <AppShell
        styles={{
          main: {
            background:
              theme.colorScheme === "dark"
                ? theme.colors.dark[8]
                : theme.colors.gray[0],
          },
        }}
        navbarOffsetBreakpoint="sm"
        asideOffsetBreakpoint="sm"
        navbar={
          <Navbar
            bg={"#000"}
            p="md"
            hiddenBreakpoint="md"
            hidden={!opened}
            width={{
              base: !opened ? 0 : 325,
              md: 325,
              lg: 325,
            }}
          >
            <JobSeekerSideBar />
          </Navbar>
        }
        header={
          <Header height={{ base: 70, md: 70 }} p="md" bg={"#000"}></Header>
        }
      >
        <Outlet />
      </AppShell>
    ) : (
      <Outlet />
    ))
  );
};

export default JobseekerHome;
